const NAMESPACE = {
  activeTabValue: 'data-appointment-type-redirect',
  lpuInfoClassNameActive: 'b-doctor-card__lpu-info_active',
  lpuInfoSelectedClassName: 'b-doctor-card__selected-lpu-info',
  selectorAppointmentTypeTab: '.appointment-tab-list',
}

/**
 * @description
 *
 * Возвращает значение выбранного таба типа приёма(клуб, телемед, на дом и тд)
 * Используется только для передачи get параметра type во время редиректа в форму записи со страницы врача/списка врачей(где есть табы с типом приёма)
 *
 * @param {object} opts -
 * @param {object} opts.target - узел, по которому произошёл клик
 * @param {string} opts.dataItem - поле 'dataItem' интерфейса 'getModuleOptionsInterface'
 *
 * @returns {string} - выбранный тип или пустая строка, если соответствующего значения не найдено
 *
 * ToDo schedule-important
 */

const getVisitType = ({ target, dataItem }: { target: HTMLElement; dataItem: string }): string => {
  const defaultResult = ''
  const filterTabsElement = document.querySelector('[data-chosen-appointment-type-filter]')

  if (filterTabsElement) {
    return filterTabsElement.getAttribute('data-chosen-appointment-type-filter') || defaultResult
  }

  if (!(target && dataItem)) {
    return defaultResult
  }

  const parentContainer = target?.closest(`[${dataItem}]`)

  if (!parentContainer) {
    return defaultResult
  }

  const selectedWpTabListMobile = [...parentContainer.querySelectorAll(`.${NAMESPACE.lpuInfoSelectedClassName}`)]
    .filter(item => getComputedStyle(item).display !== 'none')[0]
  const selectedWpTabListDesktop = parentContainer.querySelector(`.${NAMESPACE.lpuInfoClassNameActive}`)
  const activeTabWrapper = selectedWpTabListMobile || selectedWpTabListDesktop || parentContainer

  if (!activeTabWrapper) {
    return defaultResult
  }

  const tabsWrapper = activeTabWrapper.querySelector(NAMESPACE.selectorAppointmentTypeTab)
  const visitType = tabsWrapper?.getAttribute(NAMESPACE.activeTabValue)
        || activeTabWrapper.querySelector(`[${NAMESPACE.activeTabValue}]`)?.getAttribute(NAMESPACE.activeTabValue)

  return visitType || defaultResult
}

export default getVisitType
